import config from 'configs'
import { AuthenticateParams } from 'configs/constants/enums'
import { S3FileTypeEnum } from 'constants/aws'

export function getProcessImage(processId: number, imageName: string): string {
  const imageUrl: string = `${config.assetsUrl}/standard_operating_procedure/images/${processId}/${imageName}`
  return imageUrl
}

export function getCollectionImage(collectionId: number, imageName: string): string {
  const imageUrl: string = `${config.assetsUrl}/collection/media/${collectionId}/${imageName}`
  return imageUrl
}

export function getMediaImage(mediaId: number, imageName: string): string {
  const imageUrl: string = `${config.assetsUrl}/medium/images/${mediaId}/${imageName}`
  return imageUrl
}

export function getS3FileUrl(fileType: S3FileTypeEnum, organizationId: number, imageName: string): string {
  // Callers commonly pass `organizationStore.organization?.id ?? 0`, and the
  // org store is empty until some page fetches it (e.g. a direct detail-page
  // visit) — which used to assemble dead organizations/0/ URLs. Fall back to
  // the persisted active team id (written at login/team-switch, so it is
  // available synchronously) whenever the caller has no real org id.
  const persistedOrgId = Number(localStorage.getItem(AuthenticateParams.ORG_ID))
  const orgId = organizationId > 0 ? organizationId : Number.isFinite(persistedOrgId) && persistedOrgId > 0 ? persistedOrgId : 0
  const imageUrl: string = `${config.assetsUrl}/organizations/${orgId}/${fileType}s/${imageName}`
  return imageUrl
}

export function getUserImage(userId: number, imageName: string): string {
  const imageUrl: string = `${config.assetsUrl}/user/images/${userId}/${imageName}`
  return imageUrl
}
